import React, {Component} from 'react';
import { combineReducers, createStore } from 'redux';
import { Provider } from 'react-redux';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory } from 'react-router';

import store from '../store/reducers';
import * as meta from '../store/constants/meta_info';

import Contact from './Contact';
import Login from './Login';
import Home from './Home';
import Profile from './Profile';
import Privacy from './Privacy';
import Terms from './Terms';
import AppContainer from './appContainer';
import NotFound from './notFound';
import StyleGuide from './StyleGuide';

import ReactGA from 'react-ga';
ReactGA.initialize(meta.ga_tracking_code);

function fireTracking() {
  if (!meta.isDevelopmentMode) {
    ReactGA.pageview(window.location.pathname);
  }
}

export default class Routes extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Provider store={store}>
        <Router history={browserHistory} onUpdate={fireTracking}>
          <Route path='/' component={AppContainer} meta={meta}>
            <IndexRoute component={Home} meta={meta} />
            <Route path='contact' component={Contact} meta={meta} />
            <Route path='*' component={NotFound} meta={meta} />
          </Route>
        </Router>
      </Provider>
    )
  }
}

            // <Route path='login' component={Login} meta={meta} />
            // <Route path='profile' component={Profile} meta={meta} />
            // <Route path='privacy' component={Privacy} meta={meta} />
            // <Route path='terms' component={Terms} meta={meta} />
            // <Route path='contact' component={Contact} meta={meta} />
            // <Route path='style' component={StyleGuide} meta={meta} />



// WEBPACK FOOTER //
// ./src/views/router.js